import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageview, trackEvent } from '../ga';

type GAContextType = {
    trackEvent: typeof trackEvent;
};

export const GAContext = React.createContext<GAContextType | undefined>(undefined);

export const GAProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const location = useLocation();
    const isProd = process.env.NODE_ENV === 'production';

    useEffect(() => {
        if (isProd) {
            initGA();
        }
    }, []);

    useEffect(() => {
        if (isProd) {
            trackPageview(location.pathname + location.search);
        }
    }, [location]);

    return (
        <GAContext.Provider value={{ trackEvent }}>
            {children}
        </GAContext.Provider>
    );
};